<template>
  <!-- 关键字搜索页面 -->
  <div class="formGroup">
    <div class="search-banner">
      <div class="mynav">
        <img src="../assets/pubmedSearch/logo.png" alt="北智科技" class="logo">
        <div class="info">
            <img :src="head_img" alt="" class="headimg">
            <span class="username">{{username}}</span>
        </div>
      </div>
    </div>
    <search></search>
  </div>
</template>

<script>
import search from './search'
import {getToken} from '../service/getData'
import { browser } from '../config/ua'
export default {
  name: 'pubmedSearch',
  data () {
    return {
      head_img:'',
      username:'',
      
    }
  },
  methods: {
     async weixinRedirect() {
        let code = this.$route.query.code;
        let state = this.$route.query.state;
        // 目前只有微信浏览器和pc浏览器能进到这个页面，所以只考虑两种情况
        if(browser.ua.weixin){
          // if(state == 'wxbase'){ // 静默登录
          // console.log('wxbase')
          //   let wxTo = {
          //     code,
          //     source:'wx_base'
          //   };
          //   let res = await getToken(wxTo);
          //   if(res.data.status == 0){
          //     let {unionid} = res.data;
          //     window.localStorage.setItem('PUBMEDWXUNIONID',unionid);
          //   } else if(res.data.status == 2){
          //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx82e57c9f12fe7eac&redirect_uri=https%3A//ts.midbj.com/doc_search/&response_type=code&scope=snsapi_userinfo&state=wxuserinfo#wechat_redirect'
          //   }
          // } else if(state == 'wxuserinfo'){
          //   console.log('wxuserinfo')
          //   let wxTo = {
          //     code,
          //     source:'wx_info'
          //   };
          //   let res = await getToken(wxTo);
          //   if(res.data.status == 0){
          //     let {unionid} = res.data;
          //     window.localStorage.setItem('PUBMEDWXUNIONID',unionid);
          //   } else {
          //     this.$router.replace({ path: "/", replace: true });
          //   }

          // }

        } else { // pc
          if (code && state == 'pclogin') {
          //   let wxTo = {
          //     code,
          //     source:'pc'
          //   };
            // let res = await getToken(wxTo);
            // console.log(res)
            // if(res.data.status == 0){
            //   let { token,name,head_img } = res.data;
            //   window.localStorage.setItem('PUBMEDSEARCHTOKEN',token);
            //   window.localStorage.setItem('PUMMEDSEARCHUSERNAME',name);
            //   window.localStorage.setItem('PUMMEDSEARCHHEADIMG',head_img);
            //   this.username = name;
            //   this.head_img = head_img;
              // this.$router.replace({ path: "/", replace: true });
            // } else {
              // this.$router.replace({ path: "/login", replace: true });
            // }
        } else {
          // 从本地拿到头像和昵称
          this.username = window.localStorage.getItem('PUMMEDSEARCHUSERNAME');
          this.head_img = window.localStorage.getItem('PUMMEDSEARCHHEADIMG');
        }
      }
        
  }

   
  },
  mounted() {
    // this.weixinRedirect();
  },
  components:{
    search
  }
}
</script>

<style scoped>
/* 默认大屏，pc */
@media only screen and (min-width: 768px) {
  .search-banner {
    position: relative;
    width: 100%;
    height: 220px;
    background: url("../assets/pubmedSearch/bg.png") no-repeat center center;
    background-size: 100% 100%;
  }
  .mynav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 40px;
  }
  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .mynav .headimg {
      width: 45px;
      border-radius: 50%;
  }
  .mynav .username {
    font-size: 16px;
    font-weight: 600;
    margin-left: 20px;
  }

  
}

@media only screen and (max-width: 767px) and (min-width: 414px) {
  .search-banner {
    display: none;
  }
}

@media only screen and (max-width: 413px) {
  .search-banner {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pubmedSearch.vue